/* eslint-disable no-use-before-define */
import i18next from 'i18next';
import { snakeCase } from 'lodash';
import { COUNTRY_CODE_COORDINATE_MAPPING } from 'constants/CountryCoordinate';
import { titleize } from 'underscore.string';

export const sluggify = (str) => {
  if (!str) return '';
  // removes all special characters except _, /
  str = str.replace(/[^a-zA-Z0-9_/ -]/g, '');
  // replaces / with ' '
  str = str.replace(/[^a-zA-Z0-9_ ]/g, ' ');

  let splitBySpace = str.split(' ');
  if (splitBySpace.length > 1) {
    return splitBySpace.map((item) => item.toUpperCase()).join('_');
  }
  let splitByUnderScore = str.split('_');
  if (splitByUnderScore.length > 1) {
    return splitByUnderScore.map((item) => item.toUpperCase()).join('_');
  }
  return str.toUpperCase();
};

export const firstLetterTitlization = (string) => {
  return string.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
    letter.toUpperCase(),
  );
};

export const snakify = (str) => {
  return snakeCase(str).toUpperCase();
};

export const isAuthorizedToRender = (
  { requiredRoles = [], excludedUserTypes = [], excludedRegions = [] },
  auth,
) => {
  const { _type, roles, regionSettings } = auth;

  if (excludedUserTypes.length && excludedRegions.length) {
    return isExcludedUserInRegion(excludedUserTypes, excludedRegions, _type);
  }

  if (excludedUserTypes.includes(_type)) return false;

  const authorizedRole = _areAuthorizedRoles(roles, requiredRoles, _type);
  if (!authorizedRole) return !!authorizedRole;

  const authorizedRegion = _isAuthorizedRegion(excludedRegions);
  if (!authorizedRegion) return !!authorizedRegion;

  return true;
};

const isExcludedUserInRegion = (excludedUsers, excludedRegions, _type) => {
  if (!_isAuthorizedRegion(excludedRegions) && excludedUsers.includes(_type))
    return false;
  return true;
};

const _areAuthorizedRoles = (roles, requiredRoles, _type) => {
  if (!requiredRoles || !requiredRoles.length) return true;
  return (
    _isExcluded(roles, requiredRoles) ||
    requiredRoles.map((role) => role.toLowerCase()).includes(_type)
  );
};

const _isAuthorizedRegion = (excludedRegions) => {
  return !excludedRegions.includes(REGION_CODE);
};

const _isExcluded = (list, excluded = []) => {
  return excluded.some((e) => list.includes(e));
};

export const addlocalizationSlugKey = (items, key) => {
  return (items || []).map((item) => {
    return { ...item, localizationSlug: sluggify(item[key].trim()) };
  });
};

export const formattedLastSeen = (lastSeen = '') => {
  if (lastSeen) {
    const splitted = lastSeen.trim().split(' ');

    const period = parseInt(splitted[0], 10);

    if (Number.isNaN(period)) {
      return i18next.t(sluggify(lastSeen));
    }
    splitted.shift();
    const timeSlug = `PERIOD_${sluggify(splitted.join(' '))}`;
    return i18next.t(timeSlug, { period });
  }
  return lastSeen;
};

export const formatPlatformLabel = (label) => {
  if (label && label.toLowerCase().includes('unknown')) {
    return titleize(i18next.t('UNKNOWN'));
  }
  return label;
};

export const getCenterForMapBasedOnCountryCode = () => {
  const [lng, lat] = COUNTRY_CODE_COORDINATE_MAPPING[COUNTRY_CODE];
  return { lat, lng };
};
